import type { Resource } from '../../';
export const forms_error_onlyNumeric: Resource = {"default":"The {name} field must contain only numeric characters."};
